import Marquee from "react-fast-marquee";

const phrases = [
    "Learn. Lead. Empower.",
    "Youth-led.",
    "Values-driven.",
    "Impact-focused.",
    "A movement for the next century.",
];

export default function EditorialMarquee() {
    return (
        <section data-testid="marquee-section" className="hairline hairline-b py-8 md:py-12 bg-[var(--navy-deep)] overflow-hidden">
            <Marquee gradient={false} speed={35} pauseOnHover>
                {phrases.map((p, i) => (
                    <span className="marquee-item text-5xl md:text-7xl" key={i}>
                        {p}
                        <span className="marquee-dot" />
                    </span>
                ))}
            </Marquee>
        </section>
    );
}
